
import React from 'react';
import ReactModal from 'react-modal';
import Plot from 'react-plotly.js';

import Plotter from './plotter.js';
const global  = require('./global.js');

var m_plotter;

//
// Rplot - plot screen: a la 6X plotter
//                      Pitem/Popts/Prange
//                      Getfile Manageplot
//
class Rplot extends React.Component 
{
  constructor(props) 
  {
    super(props);
    this.state={ data: [], selected: [],
                           localstate: { x: [], xs: 0, xw: [], xws: 0, xn: [], xns: 0, 
                                         y: [], ys: 0, yw: [], yws: 0, yn: [], yns: 0,
                                         xmin: '', xmax: '', xminf: '', xmaxf: '', xfix: false, xmod: false, xval: '', xlog: false,
                                         ymin: '', ymax: '', yminf: '', ymaxf: '', yfix: false, ymod: false, yval: '', ylog: false,
                                         qplot: false, qline: true, qpoints: false, qdetail: false,
                                         qdate: false},
                 copynumber: {},
                 showmodels: false,
                 qstatus: false,
                 trip: 0}
    if ( typeof global.common.plotdata.plotstate.data !== 'undefined' ) this.state = global.common.plotdata.plotstate;
    this.inputRef = React.createRef();
    m_plotter = new Plotter();
    global.common.plotter = m_plotter;
  }

  render() 
  {
    global.common.plotdata.plotstate = this.state;

    const files = this.state.data.map( (v) => v );
    const orig = m_plotter.m_origin;

    var log = <span className="login" align={'center'} onClick={() => this.props.login()}>login</span>;
    if ( global.common.user!=='none'  ) log=<span>logged in as {global.common.user} </span>;
    if ( global.common.runningon!=='' ) log=<span>running on {global.common.runningon} </span>;

    return (
      <div style={{ background: this.props.structure.colour }} className='section' >
      <table><tbody><tr><td>
        <table><tbody>
            <tr><td><global.Header title={this.props.structure.title} /></td><td>{log}</td></tr>
            <tr><td><global.File files={files} selected={orig} multiple={this.state.selected} onChange={(e) => this.handleFileChange(e) } /></td>
            <td>
            <table><tbody><tr><td>
              <table><tbody><tr>
              <td><Pitem selected={this.state.localstate.xs} mnemonics={this.state.localstate.x} name={'x-axis'}
                                   onChange={(e,w) => this.changePitem(e,w,'xs') } /></td>  
              <td><Pitem selected={this.state.localstate.xws} mnemonics={this.state.localstate.xw} name={'Well'}
                                   onChange={(e,w) => this.changePitem(e,w,'xws') }/></td>  
              <td><Pitem selected={this.state.localstate.xns} mnemonics={this.state.localstate.xn} name={'Num'}
                                   onChange={(e,w) => this.changePitem(e,w,'xns') }/></td>  
              </tr>
              <tr>
              <td><Pitem selected={this.state.localstate.ys} mnemonics={this.state.localstate.y} name={'y-axis'}
                                   onChange={(e,w) => this.changePitem(e,w,'ys') }/></td>  
              <td><Pitem selected={this.state.localstate.yws} mnemonics={this.state.localstate.yw} name={'Well'}
                                   onChange={(e,w) => this.changePitem(e,w,'yws') } /></td>  
              <td><Pitem selected={this.state.localstate.yns} mnemonics={this.state.localstate.yn} name={'Num'}
                                   onChange={(e,w) => this.changePitem(e,w,'yns') } /></td>  
              </tr>
             </tbody></table>
           </td></tr>
           <tr><td>
            <table><tbody>
                <tr><Popts line={this.state.localstate.qline} points={this.state.localstate.qpoints} detail={this.state.localstate.qdetail}
                                 onChange={(e,w) => this.line(e,w) }/>
                             <td><Prange name={'x-range'} min={this.state.localstate.xmin} max={this.state.localstate.xmax}
                                          chk={this.state.localstate.xfix} val={this.state.localstate.xval}
                                          log={this.state.localstate.xlog}
                                          onChange={(e,w) => this.maxmin(e,w,'x') } /></td><td><button onClick={(e) => this.replot() }>replot</button> </td></tr>
                <tr><Topts time={this.state.localstate.qdate}
                                 onChange={(e,w) => this.datetime(e,w) }/>
                                 <td><Prange name={'y-range'} min={this.state.localstate.ymin} max={this.state.localstate.ymax} 
                                          chk={this.state.localstate.yfix}  val={this.state.localstate.yval} 
                                          log={this.state.localstate.ylog}
                                          onChange={(e,w) => this.maxmin(e,w,'y') } /></td></tr>
            </tbody></table>
           </td></tr>
        </tbody></table>
       </td></tr>
          </tbody></table>
  </td></tr><tr><td>
  
        <table><tbody>  
          <tr><td><global.Getfile name={this.props.structure.thing} onClick={(i) => this.handleNewFile(i)} /> 
            <div className="hidden" > <input type={'file'} ref={this.inputRef} value={''}
                                                accept={this.props.structure.import}
                                                onChange={(e) => this.handleFileSelect(e)} ></input> </div></td>
            <td><Manageplot onPlot={(q) => this.plot(q)} getmodel={() => this.getmodel()} 
                                                         showwellgeo={() => this.props.showwellgeo()}
                                                         cleardata={() => this.cleardata()} /></td></tr>
        </tbody></table>

          </td></tr></tbody></table>
      <ReactModal isOpen={this.state.showmodels} appElement={document.getElementById('root')} className="modellist"  >
        <div >
        <table><tbody>
        <tr>
        <td><h3>Load Results</h3>&nbsp;&nbsp;<button onClick={(e) => this.status() }>status</button></td><td><span onClick={() => this.closemodels()} >&times;</span></td></tr>
              <tr><td><global.Jobs jobs={this.props.jobs} getmodel={1} loadsummary={(c,t) => this.loadsummary(c,t) } /></td></tr>
            </tbody></table>
        </div>
      </ReactModal>
      </div>

      );
  }

  componentDidMount() 
  {
    if ( global.common.runningon==='' )
    {
      fetch(global.common.server+'/getuser',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'withCredentials': true,
          'credentials': 'include',
          'sameSite': 'none'
        },
        body: JSON.stringify({
        })
      })
      .then(res => res.json())
      .then( (result) => { this.who(result);},
              (error) => {  }
            )
    }

  }

  who(r)
  {
    if ( r.who!=='none' ) 
    {
      var newstate = Object.assign(this.state);
      global.common.user = r.who;
      newstate.trip++;
      this.setState(newstate);
    }
  }

  plot(qplot)
  {
    var newstate = Object.assign(this.state);
    newstate.localstate.qplot = qplot;
    m_plotter.getaxes(newstate.localstate);
    this.setState(newstate);
    this.props.onPlot(this.state.localstate)
  }

  replot()
  {
    var newstate = Object.assign(this.state);
    newstate.localstate.qplot = true;
    m_plotter.getaxes(newstate.localstate);
    this.setState(newstate);
    this.props.onPlot(this.state.localstate)
  }

  getmodel()
  {
    if ( global.common.user==='none' ) 
    {
      global.alertx('Login required');
      return;
    }

    var newstate = Object.assign(this.state);
    newstate.showmodels = true;
    this.setState(newstate);
  }

  closemodels()
  {
    var newstate = Object.assign(this.state);
    newstate.showmodels = false;
    this.setState(newstate);
  }

  cleardata()
  {
    var newstate = Object.assign(this.state);
    newstate.data = [];
    newstate.selected = [];
    newstate.localstate = { x: [], xs: 0, xw: [], xws: 0, xn: [], xns: 0, 
                            y: [], ys: 0, yw: [], yws: 0, yn: [], yns: 0,
                            xmin: '', xmax: '', xminf: '', xmaxf: '', xfix: false, xmod: false, xval: '', 
                            ymin: '', ymax: '', yminf: '', ymaxf: '', yfix: false, ymod: false, yval: '',
                            qplot: false, qline: true, qpoints: false, qdetail: false };
    this.setState(newstate);
    m_plotter.reset();
    this.props.onPlot(false);
  }

  line(e,w)
  {
    var newstate = Object.assign(this.state);
    if ( w==='l' )
    {
      newstate.localstate.qline=e.target.checked;
    }
    else if ( w==='p' )
    {
      newstate.localstate.qpoints=e.target.checked;
    }
    else if ( w==='d' )
    {
      newstate.localstate.qdetail=e.target.checked;
    }
    if (newstate.localstate.x.length>0) newstate.localstate.qplot = true;
    this.setState(newstate); 
  }
  
  datetime(e,w)
  {
    var newstate = Object.assign(this.state);
    if      (e.target.value=="time") newstate.localstate.qdate=false;
    else if (e.target.value=="date") newstate.localstate.qdate=true;

    if (newstate.localstate.x.length>0) newstate.localstate.qplot = true;
    this.setState(newstate); 
  }

  changePitem(event,act,what)
  {
    var newstate = Object.assign(this.state);
    if      ( act==='set' ) newstate.localstate[what] = event.target.selectedIndex;
    else if ( act==='next' && newstate.localstate[what]<newstate.localstate[what.substring(0,what.length-1)].length-1 ) newstate.localstate[what]++;
    else if ( act==='prev' && newstate.localstate[what]>0 ) newstate.localstate[what]--;
    if (newstate.localstate.x.length>0) newstate.localstate.qplot = true;
    this.setState(newstate);  
    m_plotter.clrange();
    if ( act==='prev' || act==='next')
    {
      m_plotter.xclear();
      m_plotter.getaxes(newstate.localstate);
      this.props.onPlot(this.state.localstate);
    }
  }

  maxmin(event,act,what)
  {
    var newstate = Object.assign(this.state);

    if ( what==='x' )
    {
      if     ( act==='min' ) newstate.localstate.xmin=event.target.value;
      else if( act==='max' ) newstate.localstate.xmax=event.target.value;
      else if( act==='fix' ) newstate.localstate.xfix=event.target.checked;
      else if( act==='log' ) newstate.localstate.xlog=event.target.checked;

      if ( act==='min' || act==='max' || act==='fix' )
      {
        newstate.localstate.xmod=true;
        newstate.localstate.xminf=newstate.localstate.xmin;
        newstate.localstate.xmaxf=newstate.localstate.xmax;
      }
    }
    else if ( what==='y' )
    {
      if     ( act==='min' ) newstate.localstate.ymin=event.target.value;
      else if( act==='max' ) newstate.localstate.ymax=event.target.value;
      else if( act==='fix' ) newstate.localstate.yfix=event.target.checked;
      else if( act==='log' ) newstate.localstate.ylog=event.target.checked;

      if ( act==='min' || act=='max' || act==='fix')
      {
        newstate.localstate.ymod=true;
        newstate.localstate.yminf=newstate.localstate.ymin;
        newstate.localstate.ymaxf=newstate.localstate.ymax;
      }
    }
    this.setState(newstate);   
  }

  handleNewFile()
  {
    this.inputRef.current.click();
  }

  handleFileChange(event)
  {
    var newstate = Object.assign(this.state);

    var options = event.target.options;
    m_plotter.m_origin = [];
    for ( var i=0; i<options.length; i++) 
    {
      if ( options[i].selected ) 
      {
        m_plotter.m_origin.push(i);
      }
    }
    newstate.selected=m_plotter.m_origin;

    this.setState(newstate);

    m_plotter.newplotorigin();
  }

  handleFileSelect (evt)
  {
    var files = evt.target.files; // FileList object

    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];
      var reader = new FileReader();

      reader.onload = this.onload(this);

      reader.onerror = function(event)
      {
        global.alertx("File could not be read",true);
      }

      reader.readAsText(f);
    }
  }

  onload(host)
  {
    return function(event)
    {
      //
      // Strip of call back nonsense - down to pure json
      //
      var contents = event.target.result;
      var x = contents.search('{');
      var y = contents.substring(x+1).search('{');

      var t = contents.substring(x+y);
      var z = t.lastIndexOf('return');
      var a = t.substring(0,z).lastIndexOf('}');

      contents = t.substring(0,a+1);

      var j = JSON.parse(contents);
      var n1 = j.name.substring(j.name.search('/')+1);
      var name = n1.substring(n1.search('/')+1);

      for ( var i=0; i<host.state.data.length; i++ )
      {
        if ( host.state.data[i]===name )
        {
          var copyn = 1;
          if ( typeof host.state.copynumber[name]!=='undefined' ) copyn=host.state.copynumber[name];
          name += '('+copyn.toString()+')';
          
          copyn++;

          var newstatec = Object.assign(host.state);
          newstatec.copynumber[name]=copyn;
          host.setState(newstatec);

          break;
        }
      }

      var js = [];

      if ( j.name.search("amalgamate")>0 )
      {
        js = host.process_amalgamated(j);
      }
      else
      {
        m_plotter.m_alldata.push(j);
        m_plotter.m_origin = [m_plotter.m_alldata.length-1];
      }

      global.alertx(name+' loaded',false);

      var newstate = Object.assign(host.state);
      if ( js.length>0 ) for ( var i=0; i<js.length; i++ ) newstate.data.push(js[i].name);
      else                                                 newstate.data.push(name); 
      newstate.selected = m_plotter.m_origin;
      m_plotter.localstate = newstate.localstate;
      m_plotter.newplotorigin();
      host.setState(newstate);
      host.plot(true);
    }
  }

  process_amalgamated(j)  
  {
    var n1 = j.name.substring(j.name.search('/')+1);
    var n2 = n1.substring(n1.search('/')+1);
    var name = n2.substring(0,n2.search('_'));

    var ns = 0;
    for ( var i=0; i<j.num.length; i++ )
    {
      if ( j.mnem[i].substr(0,4)==='FOPR' && j.mnem[i].substr(0,5)!=='FOPRH' ) 
      {
        var nch = j.mnem[i].substr(4);
        var n = parseInt(nch);
        ns = Math.max(ns,n);
      }
    }
    ns++;

    var js = [];
    for ( i=0; i<ns; i++ )
    {
      js.push({ mnem: [], unit: [], wg: [], num: [], data: []});
    }
    for ( i=0; i<j.mnem.length; i++ )
    {
      var num = this.getrnum(j.mnem[i]);
      if ( num>=0 && num<js.length ) this.makej(js[num],j.mnem[i],j.unit[i],j.wg[i],j.num[i],j.data[i]);
    }
    for ( i=0; i<ns; i++ )
    {
      js[i].name = name+'_'+i;
      m_plotter.m_alldata.push(js[i]);
      m_plotter.m_origin.push(m_plotter.m_alldata.length-1);
    }

    return js;
  }

  loadsummary(contents,type)
  {
    //
    // Strip of call back nonsense - down to pure json
    //
    var x = contents.search('{');
    var y = contents.substring(x+1).search('{');

    var t = contents.substring(x+y+1);
    var z = t.lastIndexOf('return');
    var a = t.substring(0,z).lastIndexOf('}');

    contents = t.substring(0,a+1);

    var j = JSON.parse(contents);

    var n1 = j.name.substring(j.name.search('/')+1);
    var name = n1.substring(n1.search('/')+1);

    for ( var i=0; i<this.state.data.length; i++ )
    {
      if ( this.state.data[i]===name )
      {
        var copyn = 1;
        if ( typeof this.state.copynumber[name]!=='undefined' ) copyn=this.state.copynumber[name];
  
        copyn++;

        var newstatec = Object.assign(this.state);
        newstatec.copynumber[name]=copyn;
        this.setState(newstatec);

        name += '('+copyn.toString()+')';

        break;
      }
    }

    var newstate = Object.assign(this.state);

    //
    // type 1: Amalgamated file
    //
    if ( type===1 )
    {  
      var js = this.process_amalgamated(j);

      for ( var i=0; i<js.length; i++ ) newstate.data.push(js[i].name);
      m_plotter.initvecs('TIME','FOPR');
    }
    else if ( type===2 )
    {
      m_plotter.initvecs('$A','FOPT');
      m_plotter.m_alldata.push(j);
      m_plotter.m_origin = [m_plotter.m_alldata.length-1];
      newstate.data.push(name);
    }
    //
    // Regular summary file
    //
    else
    {
      m_plotter.initvecs('TIME','FOPR');
      m_plotter.m_alldata.push(j);
      m_plotter.m_origin = [m_plotter.m_alldata.length-1];
      newstate.data.push(name);
    }
    global.alertx(name+' loaded',false);

    m_plotter.localstate = newstate.localstate;
    m_plotter.newplotorigin();
    this.setState(newstate);
    this.plot(true);
  }

  //
  // Make a summary from an amalgamated file
  //
  makej(newj,mnem,unit,wg,num,data)
  {
    var nn = -1;
    for ( var i=mnem.length-1; i>=0; i-- )
    {
      var c = parseInt(mnem.substring(i));
      if ( isNaN(c) ) break;
      nn = i;
    }
    if ( nn>0 ) mnem = mnem.substring(0,nn);

    newj.mnem.push(mnem);
    newj.unit.push(unit);
    newj.wg.push(wg);
    newj.num.push(num);
    newj.data.push(data);
  }

  //
  // Try and work out the run number from the mnemonic
  //
  getrnum(mnem)
  {
    var nn=-1;
    for ( var i=mnem.length-1; i>=0; i-- )
    {
      var c = parseInt(mnem.substring(i));
      if ( isNaN(c) || mnem.substring(i-1,i)==='_' ) break;
      nn = i;
    }
    var ret = -1;
    if ( nn>0  ) ret = parseInt(mnem.substring(nn));
    return ret;
  }

  status()
  {
    if ( global.common.user==='none' ) 
    {
      global.alertx('Login required');
      return;
    }

    fetch(global.common.server+'/'+global.common.user+'/jobs.json')
    .then(res => res.json())
    .then( (result) => { this.props.processjobs(result);},
           (error) => { this.error(error); }
         )

    var newstate = Object.assign(this.state);
    newstate.qstatus = true;
    this.setState(newstate);
  }

  error(err)
  {
    global.alertx("error getting jobs status",true);
  }

}

class Pitem extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props);
  }

  render() 
  {
    const mnemonics = this.props.mnemonics;
    const listopts=mnemonics.map((string) => <option key={string} value={string}>{string}</option> );
    return (
      <div className="pitem">{this.props.name}:
        <select  value={mnemonics[this.props.selected]} onChange={(e) => this.props.onChange(e,'set') } >
         {listopts}
        </select>&nbsp;
        <button onClick={(e) => this.props.onChange(e,'next') }>Next</button>&nbsp;
        <button onClick={(e) => this.props.onChange(e,'prev') }>Prev</button>&nbsp;
      </div>
    );
  }
}

class Prange extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props);
  }

  render() 
  {
    return (<div>
      {this.props.name}:
      <input type={'text'} value={this.props.min} onChange={(e) => this.props.onChange(e,'min') } className='prange' />&nbsp;
      <input type={'text'} value={this.props.max} onChange={(e) => this.props.onChange(e,'max') } className='prange' />&nbsp;Fix:
      <input type={'checkbox'} checked={this.props.chk} onChange={(e) => this.props.onChange(e,'fix') } />&nbsp;Log:
      <input type={'checkbox'} checked={this.props.log} onChange={(e) => this.props.onChange(e,'log') } />
      {/*  &nbsp; &nbsp;{d}: <input type={'text'} value={this.props.val} readOnly={true} className='prange'/> */}
      </div>);
  }
}

class Popts extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props);
  }

  render() 
  {
    return (
      <td align={'center'}>
        <div className='popts' align={'center'}>
          Line:
          <input type={'checkbox'} checked={this.props.line} onChange={(e) => this.props.onChange(e,'l') } />
          Points:
          <input type={'checkbox'} checked={this.props.points} onChange={(e) => this.props.onChange(e,'p') } />
          Detail:
          <input type={'checkbox'} checked={this.props.detail} onChange={(e) => this.props.onChange(e,'d') } /> 
        </div>
      </td>
      );
  }
}

class Topts extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props);
    this.qfirst = true;
  }

  render() 
  {
    if (this.qfirst)
    {
      this.qfirst = false;
      return (
      <td align={'center'}>
        <div className='topts' align={'center'} value={'time'}>
          Time:
          <input type={'radio'} value={'time'} name={'datetime'} checked onChange={(e) => this.props.onChange(e,'t') } />
          Date:
          <input type={'radio'} value={'date'} name={'datetime'} onChange={(e) => this.props.onChange(e,'d') } />
        </div>
      </td>
      );
    }
    else
    {
      return (
      <td align={'center'}>
        <div className='topts' align={'center'} value={'time'}>
          Time:
          <input type={'radio'} value={'time'} name={'datetime'} onChange={(e) => this.props.onChange(e,'t') } />
          Date:
          <input type={'radio'} value={'date'} name={'datetime'} onChange={(e) => this.props.onChange(e,'d') } />
        </div>
      </td>
      );
    }
  }
}

class Manageplot extends React.Component 
{
  constructor(props) 
  {
    super(props)
    this.state={ plotwhat: 0, showsrvs: false, jobs: [] }
  }
  render() 
  {
    var showbutton='show SRV';
    if ( this.state.plotwhat===1 ) showbutton='SRV&Plot';
    if ( this.state.plotwhat===2 ) showbutton='no SRV';

    return (
      <div className="plotbuttons">
      <table><tbody><tr>
        <td><button onClick={() => this.props.getmodel()   } >get model</button></td>
        <td><button onClick={() => this.props.onPlot(true) } >plot</button></td>
        <td><button onClick={() => this.colour()           } >colour</button></td>
        <td><button onClick={() => this.clear()            } >clear</button></td>
        <td><button onClick={() => this.showwellgeo()      } >{showbutton}</button></td>
        <td><button onClick={() => this.props.cleardata()  } >cleardata</button></td>
      </tr></tbody></table>
      <ReactModal isOpen={this.state.showsrvs} appElement={document.getElementById('root')} className="modellist"  >
        <div >
        <table><tbody>
        <tr>
        <td><h3>Load SRV</h3>&nbsp;&nbsp;<button onClick={(e) => this.status() }>status</button></td><td><span onClick={() => this.closemodels(true)} >&times;</span></td></tr>
              <tr><td><global.Jobs jobs={this.state.jobs} getmodel={2} loadsummary={(c,i) => this.loadsrv(c,i) } /></td></tr>
            </tbody></table>
        </div>
      </ReactModal>
      </div>
    );
  }

  clear()
  {
    m_plotter.xclear();
    m_plotter.clrange();
    this.props.onPlot(false);
  }

  colour()
  {
    m_plotter.colour();
    this.props.onPlot(false);
  }

  showwellgeo()
  {
    if ( global.common.user==='none' ) 
    {
      global.alertx('Login required');
      return;
    }

    var newstate = Object.assign(this.state);
    if      ( this.state.plotwhat===0 ) newstate.showsrvs = true;
    else if ( this.state.plotwhat===1 ) { newstate.plotwhat = 2; this.props.showwellgeo(); }
    else if ( this.state.plotwhat===2 ) { newstate.plotwhat = 0; this.props.showwellgeo(); }
    this.setState(newstate);
  }

  closemodels(qnull)
  {
    var newstate = Object.assign(this.state);
    if      ( this.state.plotwhat===0 ) newstate.plotwhat = 1;
    else if ( this.state.plotwhat===1 ) newstate.plotwhat = 0;
    if ( qnull ) newstate.plotwhat = 0;
    newstate.showsrvs = false;
    this.setState(newstate);
    if ( !qnull ) this.props.showwellgeo();
  }

  loadsrv(contents,index)
  {
    if ( contents[0]!=='{' ) { this.closemodels(true); return; }

    global.common.srv.data = JSON.parse(contents);
    for ( var i=0; i<global.common.srv.data.z.length; i++ )
    {
      global.common.srv.data.z[i] = -global.common.srv.data.z[i]; 
    }
    global.common.srv.go = true;
    global.common.srv.selected = 0;
    var name = this.state.jobs[index].name;
    var rev = -1;
    var res = global.common.sixxcs.formation.sect;
    var rname = '';

    for ( i=0; i<global.common.data.build.length; i++ )
    {
      if ( name===global.common.data.build[i].name )
      {
        rname = global.common.data.build[i].metadata[res].name;
        rev   = global.common.data.build[i].metadata[res].rev;
        break;
      }
    }

    var qfound=false;
    for ( i=0; i<global.common.data[res].length; i++ )
    {
      if ( global.common.data[res][i].name===rname ) { qfound = true; global.common.srv.selected=i; }
    }

    //
    // Deal with rotation
    //
    if ( qfound && global.common.data[res][global.common.srv.selected].data.stress[0].para[3].value!==0 )
    {
      const pi = Math.PI;
      var rot = 2*pi*global.common.data[res][global.common.srv.selected].data.stress[0].para[3].value/360;
      var a00 = Math.cos(rot); var a01 = -Math.sin(rot);
      var a10 = Math.sin(rot); var a11 =  Math.cos(rot);

      for ( var i=0; i<global.common.srv.data.x.length; i++ )
      {
        var x = a00*global.common.srv.data.x[i] + a01*global.common.srv.data.y[i];
        var y = a10*global.common.srv.data.x[i] + a11*global.common.srv.data.y[i];

        global.common.srv.data.x[i]=x;
        global.common.srv.data.y[i]=y;
      }      
    }

    global.common.srv.data.opacity=0.3;
    global.common.srv.data.color='rgb(300,100,200)';

    if ( qfound ) global.alertx(' SRV loaded for Reservoir:'+rname+' rev:'+rev,false);
    else          global.alertx(' SRV loaded for Reservoir:'+rname+' Not found in the project',false);
    

    this.closemodels(false);
  }

  status()
  {
    if ( global.common.user==='none' ) 
    {
      global.alertx('Login required');
      return;
    }
   
    fetch(global.common.server+'/'+global.common.user+'/jobs.json')
    .then(res => res.json())
    .then( (result) => { this.processjobs(result);},
           (error) => { this.error(error); }
         )
  }

  processjobs(response)
  {
    var newstate = Object.assign(this.state);
    newstate.jobs = response.reverse();
    this.setState(newstate);
  }

  error(error)
  {
    global.alertx("error getting jobs/srv status",true);
  }

}

//
// Dplot - display area for plotting (vector plots)
//         svg
//
class Dplot extends React.Component 
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }
  componentDidMount() 
  {
    this.createChart();
  }
  componentDidUpdate() 
  {   
    this.createChart();
  }
  createChart() 
  {
    m_plotter.initvis(this.node);

    if ( this.props.localstate.qplot )
    {
      m_plotter.localstate = this.props.localstate;
      m_plotter.newplot(true);
      this.props.onPlot();
    }
  }
  
  render() 
  {
    return (<svg ref={node => this.node=node}
              width={1000} height={800}>
            </svg>);
  }
}

//
// Pyplot - display area for plotting (vector plots)
//          using Plotly
//
class Pyplot extends React.Component 
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }
  
  render() 
  {
    m_plotter.qplotly = true;
    if ( this.props.qtwo )
    {
      m_plotter.data.baselayout.width = 500;
      m_plotter.data.baselayout.showlegend = false;
    }
    else
    {
      m_plotter.data.baselayout.width = 1100;
      m_plotter.data.baselayout.showlegend = true;
    }

    var pydata = m_plotter.newplot(this.props.qplot);
    if ( !this.props.qplot && m_plotter.nlines()>0   ) pydata = m_plotter.actualplot();
    if ( !this.props.qplot && m_plotter.nlines()===0 ) pydata = {};
    var pylayout = m_plotter.layout();

    if ( typeof pydata!=='undefined' && pydata.length>0 )
    {
      return(     
        <div id="lineplot" > 
        <Plot
          data={pydata}
          layout={pylayout} /> 
        </div>);
    }
    else
    {
      return(     
        <div id="lineplot" > 
        </div>);
    }
  }
}

export { Rplot, Dplot, Pyplot };



